module.exports = __webpack_public_path__ + "img/کارت-ویزیت-پی-وی-سی-760-متالیک.4b5fbc05.png";